import { FC, useEffect, useState } from "react";
import Button from "../Button";
import ButtonGroup from "../Button/Group";
import Icon from "../Icon";
import { FeedbackThumbsProps } from "./types";
import { styles } from "./styles";

/**
 * Feedback component displaying thumbs up and down buttons.
 */
const FeedbackThumbs: FC<FeedbackThumbsProps> = ({ value, onChange }) => {
  const [selected, setSelected] = useState<"positive" | "negative" | undefined>(
    value
  );

  useEffect(() => {
    setSelected(value);
  }, [value]);

  const handleClick = (sentiment: "positive" | "negative") => {
    setSelected(sentiment);
    onChange?.(sentiment);
  };

  return (
    <ButtonGroup gap="4" justifyContent="start">
      <Button
        prefix={<Icon name="ThumbsUp" size="small" />}
        onClick={() => handleClick("positive")}
        variant="ghost"
        ariaLabel="Positive feedback"
        css={[styles.thumb, selected === "positive" && styles.thumbSelected]}
      />
      <Button
        prefix={<Icon name="ThumbsDown" size="small" />}
        onClick={() => handleClick("negative")}
        variant="ghost"
        ariaLabel="Negative feedback"
        css={[styles.thumb, selected === "negative" && styles.thumbSelected]}
      />
    </ButtonGroup>
  );
};

export default FeedbackThumbs as typeof FeedbackThumbs & {
  displayName?: string;
};
